{
  "removeAriaLabel": "Fjern"
}
